module.exports = __webpack_public_path__ + "img/10.15638025.png";